/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export const bd_center = createAsyncThunk(
  'saada/bd_center',
  async (p: any, store: any) => {
    const resp = await http.post(
      'live/hiya_socialize/bd_center',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

const initialState: {
  home: any
} = {
  home: {},
}

export function useBDCenter() {
  return useSelector((store) => store.SaadaBDCenter)
}

export const SaadaBDCenterSlice = createSlice({
  name: 'SaadaBDCenter',
  initialState,
  reducers: {
    updatePayPrice: (state, action: PayloadAction<any>) => {
      const {home} = state
      Object.assign(state, {
        home: {
          ...home,
          ...action.payload,
        },
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(bd_center.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, {home: data})
    })
  },
})

export default SaadaBDCenterSlice.reducer
export const SaadaBDCenterActions = SaadaBDCenterSlice.actions
